function renderJSON(value) {
  const ul = document.createElement("ul");
  ul.classList.add("json");

  if (value === null || typeof value !== "object") {
    const li = document.createElement("li");

    const span = document.createElement("span");
    span.classList.add("json-value");
    span.textContent = JSON.stringify(value);

    li.appendChild(span);
    ul.appendChild(li);
    return ul;
  }

  if (Array.isArray(value)) {
    value.forEach((item, index) => {
      const li = document.createElement("li");
      li.append(`[${index}] `);

      if (item !== null && typeof item === "object") {
        const span = document.createElement("span");
        span.textContent = "…";
        span.classList.add("json-key", "collapsible");

        const child = renderJSON(item);
        child.classList.add("hidden");

        li.append(span, child);
      } else {
        const span = document.createElement("span");
        span.classList.add("json-value");
        span.textContent = JSON.stringify(item);

        li.appendChild(span);
      }

      ul.appendChild(li);
    });

    return ul;
  }

  Object.entries(value).forEach(([key, val]) => {
    const li = document.createElement("li");

    const keySpan = document.createElement("span");
    keySpan.textContent = key;
    keySpan.classList.add("json-key");

    if (val !== null && typeof val === "object") {
      keySpan.classList.add("collapsible");

      const child = renderJSON(val);
      child.classList.add("hidden");

      li.append(keySpan, ": ", child);
    } else {
      const valueSpan = document.createElement("span");
      valueSpan.classList.add("json-value");
      valueSpan.textContent = JSON.stringify(val);

      li.append(keySpan, ": ", valueSpan);
    }

    ul.appendChild(li);
  });

  return ul;
}

function initJSONViews(root = document) {
  root.querySelectorAll(".json-container").forEach(container => {
    if (container.dataset.rendered === "true") return;

    let value = container.dataset.json;

    try {
      while (typeof value === "string") {
        value = JSON.parse(value);
      }
    } catch (e) {
      console.warn("Unable to parse JSON", e);
      container.textContent = container.dataset.json;
      return;
    }

    container.replaceChildren(renderJSON(value));
    container.dataset.rendered = "true";
  });
}

document.addEventListener("click", event => {
  const key = event.target.closest(".collapsible");
  if (!key) return;

  key.classList.toggle("open");

  const child = [...key.parentElement.children].find(el =>
    el.classList?.contains("json")
  );

  if (child) {
    child.classList.toggle("hidden");
  }
});

["DOMContentLoaded", "turbo:load"].forEach(event =>
  document.addEventListener(event, () => initJSONViews())
);
